import { Dispatch } from 'redux'
import { clearPrescriptionLatest } from 'core/modules/prescriptionLatest'

export function callClearPrescriptionLatest() {
  return async (dispatch: Dispatch) => {
    dispatch(clearPrescriptionLatest())
  }
}
